import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getLoginUrl = async (lineUserId, loginTags) => {
  try {
    const response = await axios.post(`${BASE_URL}/login/hotai`, {
      user_id: lineUserId,
      locations: loginTags || [],
    });
    return response.data.data.redirect_url;
  } catch (err) {
    console.error('error occurred while fetching data', err);
    throw err;
  }
};

export const loginComplete = async (idToken, oneUserId, oneUserCode) => {
  try {
    const response = await axios.post(`${BASE_URL}/login/hotai/complete`, {
      token: idToken,
      one_user_id: oneUserId,
      one_user_code: oneUserCode,
    });
    return response.data;
  } catch (err) {
    console.error('error occurred while fetching data', err);
    throw err;
  }
};
